function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { appActions } from '../../reducers/app.reducer';
import { FaBars, FaComment } from 'react-icons/fa6';
import SubHeader from './SubHeader.react';
var Header = function Header(_ref) {
  var toggleHamburgerMenuAction = _ref.toggleHamburgerMenuAction;
  return /*#__PURE__*/React.createElement("header", {
    className: "header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header__logo",
    onClick: function onClick() {
      toggleHamburgerMenuAction(false);
    }
  }, /*#__PURE__*/React.createElement(NavLink, {
    to: "/"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/logo/logo.png",
    className: "header__logo--desktop",
    alt: "Posillico Wash Plant"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/logo/logo-mobile.png",
    className: "header__logo--mobile",
    alt: "Posillico Wash Plant"
  }))), /*#__PURE__*/React.createElement(NavLink, {
    to: "/"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/logo/wash-plant-logo-nav-blue@3x.png",
    className: "header__washplant",
    alt: "Posillico Wash Plant",
    onClick: function onClick() {
      toggleHamburgerMenuAction(false);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "header__contact"
  }, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "mailto:washplant@posillicoinc.com"
  }, "washplant@posillicoinc.com")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "tel:+16313905777"
  }, "631.390.5777")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Social, {
    media: "facebook"
  }), /*#__PURE__*/React.createElement(Social, {
    media: "linkedin"
  }), /*#__PURE__*/React.createElement(Social, {
    media: "instagram"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "header__toggle-mobile-menu",
    onClick: function onClick() {
      return toggleHamburgerMenuAction();
    }
  }, /*#__PURE__*/React.createElement(FaBars, null)), /*#__PURE__*/React.createElement("div", {
    className: "header__mobile-contact-info",
    onClick: function onClick() {}
  }, /*#__PURE__*/React.createElement(NavLink, {
    to: "/contact"
  }, /*#__PURE__*/React.createElement(FaComment, null))), /*#__PURE__*/React.createElement("div", {
    className: "header__border"
  }), /*#__PURE__*/React.createElement(SubHeader, null));
};
var mdtp = {
  toggleHamburgerMenuAction: appActions.toggleHamburgerMenu
};
export default connect(null, mdtp)(Header);
var Social = function Social(_ref2) {
  var media = _ref2.media;
  var _useState = useState(uuid()),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hover = _useState4[0],
    setHover = _useState4[1];
  useEffect(function () {
    $("#".concat(id)).css({
      opacity: hover ? 1 : 0
    });
  }, [hover]);
  var url = {
    facebook: 'https://www.facebook.com/Posillico-wash-plant',
    linkedin: 'https://www.linkedin.com/company/posillico-wash-plant',
    instagram: 'https://www.instagram.com/posillico_washplant'
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "header__social-icon",
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: url[media],
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/".concat(media, "-icon.png")
  }), /*#__PURE__*/React.createElement("img", {
    id: id,
    src: "/public/images/".concat(media, "-icon-rollover.png"),
    className: "header__social-icon--ro"
  })));
};